<template>
  <div>
    <!-- <div>
      <b
        ><h1>
          Page Under Development (Below is the dummy data for representation)
        </h1>
      </b>
    </div>
    <hr /> -->

    <div class="home-home">
      <div class="home-home__topbar">
        <b-nav pills class="home-home__main-tabs">
          <b-nav-item
            :active="selectedMainTab === 'events'"
            @click="selectedMainTab = 'events'"
          >
            Events
          </b-nav-item>
          <b-nav-item
            :active="selectedMainTab === 'analytics'"
            @click="selectedMainTab = 'analytics'"
          >
            Analytics
          </b-nav-item>
        </b-nav>
      </div>

      <!-- EVENTS TAB (kept the same UI) -->
      <div v-show="selectedMainTab === 'events'" class="home-events">
        <div class="home-events__top-summary">
          <b-row class="mb-3 align-items-stretch">
            <b-col cols="12" md="5" lg="4">
              <div class="home-events__kpi-stack">
                <div class="home-analytics__kpi">
                  <div class="text-muted home-analytics__kpi-label">
                    Upcoming events
                  </div>
                  <div class="home-analytics__kpi-value">
                    {{ analyticsUpcomingCount }}
                  </div>
                </div>
                <div class="home-analytics__kpi">
                  <div class="text-muted home-analytics__kpi-label">
                    Past events
                  </div>
                  <div class="home-analytics__kpi-value">
                    {{ analyticsPastCount }}
                  </div>
                </div>
                <div class="home-analytics__kpi">
                  <div class="text-muted home-analytics__kpi-label">
                    Events this week
                  </div>
                  <div class="home-analytics__kpi-value">
                    {{ analyticsThisWeekCount }}
                  </div>
                </div>
                <div class="home-analytics__kpi">
                  <div class="text-muted home-analytics__kpi-label">
                    Events this month
                  </div>
                  <div class="home-analytics__kpi-value">
                    {{ analyticsThisMonthCount }}
                  </div>
                </div>
              </div>
            </b-col>

            <b-col cols="12" md="7" lg="8">
              <b-card class="home-analytics__card h-100" no-body>
                <b-card-body>
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <h5 class="mb-0"><b>Next event</b></h5>
                    <b-badge variant="info" pill>Upcoming</b-badge>
                  </div>

                  <div v-if="analyticsNextEvent" class="mt-2">
                    <div class="home-analytics__next-title">
                      {{ analyticsNextEvent.event_name }}
                    </div>
                    <div class="text-muted">
                      {{
                        moment(analyticsNextEvent.event_start_date).format(
                          "DD/MM/YYYY",
                        )
                      }}
                    </div>
                  </div>
                  <div v-else class="text-muted mt-2">
                    No upcoming event found in the loaded list.
                  </div>

                  <template v-if="analyticsNextEvent">
                    <hr class="home-events__next-divider" />

                    <h6 class="home-analytics__subhead mb-2">
                      <b>Snapshot</b>
                    </h6>

                    <div v-if="nextEventSnapshotLoading" class="text-muted">
                      Loading snapshot…
                    </div>
                    <div v-else-if="nextEventSnapshotData">
                      <div class="home-analytics__snapshot-grid">
                        <div class="home-analytics__snapshot-item">
                          <div class="text-muted small">Transactions</div>
                          <div class="home-analytics__snapshot-value">
                            {{ nextEventSnapshotData.event_total_trans || 0 }}
                          </div>
                        </div>
                        <div class="home-analytics__snapshot-item">
                          <div class="text-muted small">
                            Voucher transactions
                          </div>
                          <div class="home-analytics__snapshot-value">
                            {{
                              nextEventSnapshotData.event_total_voucher_trans ||
                              0
                            }}
                          </div>
                        </div>
                        <div class="home-analytics__snapshot-item">
                          <div class="text-muted small">Seats booked</div>
                          <div class="home-analytics__snapshot-value">
                            {{
                              nextEventSnapshotData.event_total_bookedSeats || 0
                            }}
                          </div>
                        </div>
                        <div class="home-analytics__snapshot-item">
                          <div class="text-muted small">Seats scanned</div>
                          <div class="home-analytics__snapshot-value">
                            {{
                              nextEventSnapshotData.event_total_seats_scanned ||
                              0
                            }}
                          </div>
                        </div>
                      </div>

                      <div
                        v-if="
                          nextEventSnapshotData.voucherSummaryArray &&
                          nextEventSnapshotData.voucherSummaryArray.length
                        "
                        class="mt-3"
                      >
                        <div class="home-analytics__subhead mb-1">
                          <b>Voucher summary</b>
                        </div>
                        <table class="home-analytics__mini-table">
                          <tr>
                            <td>Voucher Code</td>
                            <td>Seat Type</td>
                            <td>Count</td>
                          </tr>
                          <tr
                            v-for="(
                              voc, indexVoc
                            ) in nextEventSnapshotData.voucherSummaryArray"
                            :key="'next-voc-' + indexVoc"
                          >
                            <td>{{ voc.VoucherCode }}</td>
                            <td>{{ voc.SeatType }}</td>
                            <td>{{ voc.Count }}</td>
                          </tr>
                        </table>
                      </div>

                      <div
                        v-if="
                          nextEventSnapshotData.eventScheduleSummary &&
                          nextEventSnapshotData.eventScheduleSummary.length
                        "
                        class="mt-3"
                      >
                        <div class="home-analytics__subhead mb-1">
                          <b>Schedule details</b>
                        </div>
                        <b-list-group horizontal="md">
                          <b-list-group-item
                            variant="light"
                            v-for="(
                              itemType, indexType
                            ) in nextEventSnapshotData.eventScheduleSummary"
                            :key="'next-sch-' + indexType"
                            class="home-analytics__schedule-card"
                          >
                            <div class="text-center">
                              <div class="home-analytics__schedule-title">
                                {{
                                  moment(itemType.event_sch_date).format(
                                    "DD/MM/YYYY",
                                  )
                                }}
                                -
                                {{ itemType.event_sch_time }}
                              </div>

                              <table
                                class="mt-2 home-analytics__mini-table"
                                style="width: 100%"
                              >
                                <tr>
                                  <td>Seat Type</td>
                                  <td>
                                    Total
                                    <b-badge pill>
                                      {{ itemType.sch_max_capacity }}</b-badge
                                    >
                                  </td>
                                  <td>
                                    Sold
                                    <b-badge pill variant="success">
                                      {{ itemType.sch_sold_seats }}</b-badge
                                    >
                                  </td>
                                  <td>
                                    Avail
                                    <b-badge pill variant="danger">
                                      {{
                                        parseFloat(itemType.sch_max_capacity) -
                                        parseFloat(itemType.sch_sold_seats)
                                      }}</b-badge
                                    >
                                  </td>
                                </tr>
                                <tr
                                  v-for="(
                                    itemSeat, indexSeat
                                  ) in itemType.seatTypes"
                                  :key="
                                    'next-seat-' + indexType + '-' + indexSeat
                                  "
                                >
                                  <td>{{ itemSeat.seat_type }}</td>
                                  <td>{{ itemSeat.total_allocated }}</td>
                                  <td>{{ itemSeat.count }}</td>
                                  <td>
                                    {{
                                      parseFloat(itemSeat.total_allocated) -
                                      parseFloat(itemSeat.count)
                                    }}
                                  </td>
                                </tr>
                              </table>
                            </div>
                          </b-list-group-item>
                        </b-list-group>
                      </div>
                    </div>

                    <div v-else class="text-muted">
                      No snapshot data for this event yet.
                    </div>
                  </template>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </div>

        <b-card class="home-events__shell" no-body>
          <div class="home-events__header">
            <div
              class="d-flex align-items-start justify-content-between flex-wrap"
            >
              <div class="pr-2">
                <div class="home-events__title-row">
                  <h4 class="mb-0"><b>Events</b></h4>
                  <b-badge variant="primary" class="ml-2">{{
                    displayedEvents.length
                  }}</b-badge>
                </div>
                <div class="text-muted home-events__subtitle">
                  {{ selectedEventBucketTitle }} •
                  {{
                    selectedEventBucket === "upcoming"
                      ? "sorted by nearest date"
                      : "sorted by most recent"
                  }}
                </div>
              </div>

              <div class="d-flex align-items-center home-events__controls">
                <b-button-group class="home-events__tabs">
                  <b-button
                    @click="selectedEventBucket = 'upcoming'"
                    :variant="
                      selectedEventBucket === 'upcoming' ? 'primary' : 'light'
                    "
                    class="home-events__tab-btn"
                  >
                    Upcoming
                  </b-button>
                  <b-button
                    @click="selectedEventBucket = 'past'"
                    :variant="
                      selectedEventBucket === 'past' ? 'primary' : 'light'
                    "
                    class="home-events__tab-btn"
                  >
                    Past
                  </b-button>
                </b-button-group>

                <b-form-input
                  v-model="eventSearch"
                  class="ml-2 home-events__search"
                  size="sm"
                  placeholder="Search events…"
                />
              </div>
            </div>
          </div>

          <b-card-text class="home-events__body">
            <b-row>
              <b-col cols="12" md="12">
                <div class="home-events__panel">
                  <div
                    v-if="!displayedEvents || !displayedEvents.length"
                    class="home-events__empty text-center text-muted"
                  >
                    No events found.
                  </div>

                  <div v-else class="accordion" role="tablist">
                    <b-card
                      v-for="itemEvent in displayedEvents"
                      :key="itemEvent.event_id"
                      no-body
                      class="mb-2 home-events__event-card"
                    >
                      <b-card-header
                        header-tag="header"
                        class="p-0 home-events__event-header"
                        role="tab"
                      >
                        <b-button
                          @click="getEventDataById(itemEvent.event_id)"
                          block
                          size="sm"
                          variant="light"
                          class="home-events__event-btn"
                          :class="{
                            'home-events__event-btn--active':
                              selectedEventId == itemEvent.event_id,
                          }"
                        >
                          <div
                            class="d-flex align-items-start justify-content-between"
                          >
                            <div class="pr-2">
                              <div class="home-events__event-title">
                                <b>{{ itemEvent.event_name }}</b>
                              </div>
                              <div
                                class="text-muted home-events__event-subtitle"
                              >
                                {{
                                  moment(itemEvent.event_start_date).format(
                                    "DD/MM/YYYY",
                                  )
                                }}
                                -
                                {{
                                  moment(itemEvent.event_end_date).format(
                                    "DD/MM/YYYY",
                                  )
                                }}
                              </div>
                            </div>

                            <b-badge
                              :variant="
                                selectedEventBucket === 'upcoming'
                                  ? 'success'
                                  : 'secondary'
                              "
                              pill
                            >
                              {{
                                selectedEventBucket === "upcoming"
                                  ? "UPCOMING"
                                  : "PAST"
                              }}
                            </b-badge>
                          </div>
                        </b-button>
                      </b-card-header>
                      <b-collapse
                        :id="`accordion-` + itemEvent.event_id"
                        :visible="
                          selectedEventId == itemEvent.event_id ? true : false
                        "
                        :accordion="`accordion-` + itemEvent.event_id"
                        role="tabpanel"
                      >
                        <b-card-body>
                          <b-card-text>
                            <b-list-group>
                              <b-list-group-item
                                ><b
                                  >Total Transaction :
                                  {{
                                    eventData && eventData.event_total_trans
                                      ? eventData.event_total_trans
                                      : 0
                                  }}
                                </b></b-list-group-item
                              >

                              <b-list-group-item
                                ><b
                                  >Voucher Transaction :
                                  {{
                                    eventData &&
                                    eventData.event_total_voucher_trans
                                      ? eventData.event_total_voucher_trans
                                      : 0
                                  }}
                                </b>
                                <table
                                  v-if="
                                    eventData &&
                                    eventData.voucherSummaryArray &&
                                    eventData.voucherSummaryArray.length
                                  "
                                  class="mt-1"
                                  style="width: 50%"
                                >
                                  <tr>
                                    <td>Voucher Code</td>
                                    <td>Seat Type</td>
                                    <td>Count</td>
                                  </tr>
                                  <tr
                                    v-for="(
                                      voc, indexVoc
                                    ) in eventData.voucherSummaryArray"
                                    :key="indexVoc"
                                  >
                                    <td>{{ voc.VoucherCode }}</td>
                                    <td>{{ voc.SeatType }}</td>
                                    <td>{{ voc.Count }}</td>
                                  </tr>
                                </table>
                              </b-list-group-item>

                              <b-list-group-item
                                ><b
                                  >Total Seats Booked :
                                  {{
                                    eventData &&
                                    eventData.event_total_bookedSeats
                                      ? eventData.event_total_bookedSeats
                                      : 0
                                  }}
                                </b></b-list-group-item
                              >

                              <b-list-group-item
                                ><b
                                  >Total Seats Scanned :
                                  {{
                                    eventData &&
                                    eventData.event_total_seats_scanned
                                      ? eventData.event_total_seats_scanned
                                      : 0
                                  }}
                                </b></b-list-group-item
                              >

                              <div class="mt-1">
                                <h5>
                                  <b><u>Schedule Details</u></b>
                                </h5>
                                <b-list-group
                                  v-if="
                                    eventData &&
                                    eventData.eventScheduleSummary &&
                                    eventData.eventScheduleSummary.length
                                  "
                                  horizontal="md"
                                >
                                  <b-list-group-item
                                    variant="secondary"
                                    v-for="(
                                      itemType, indexType
                                    ) in eventData.eventScheduleSummary"
                                    :key="indexType"
                                  >
                                    <div class="text-center">
                                      <h5>
                                        {{
                                          moment(
                                            itemType.event_sch_date,
                                          ).format("DD/MM/YYYY")
                                        }}
                                        -
                                        {{ itemType.event_sch_time }}
                                      </h5>

                                      <table class="mt-1" style="width: 100%">
                                        <tr>
                                          <td>Seat Type</td>
                                          <td>
                                            Total Seats
                                            <b-badge pill>
                                              {{
                                                itemType.sch_max_capacity
                                              }}</b-badge
                                            >
                                          </td>
                                          <td>
                                            Sold
                                            <b-badge pill variant="success">
                                              {{
                                                itemType.sch_sold_seats
                                              }}</b-badge
                                            >
                                          </td>
                                          <td>
                                            Available
                                            <b-badge pill variant="danger">
                                              {{
                                                parseFloat(
                                                  itemType.sch_max_capacity,
                                                ) -
                                                parseFloat(
                                                  itemType.sch_sold_seats,
                                                )
                                              }}</b-badge
                                            >
                                          </td>
                                        </tr>
                                        <tr
                                          v-for="(
                                            itemSeat, indexSeat
                                          ) in itemType.seatTypes"
                                          :key="indexSeat"
                                        >
                                          <td>{{ itemSeat.seat_type }}</td>
                                          <td>
                                            {{ itemSeat.total_allocated }}
                                          </td>
                                          <td>{{ itemSeat.count }}</td>
                                          <td>
                                            {{
                                              parseFloat(
                                                itemSeat.total_allocated,
                                              ) - parseFloat(itemSeat.count)
                                            }}
                                          </td>
                                        </tr>
                                      </table>
                                    </div>
                                  </b-list-group-item>
                                </b-list-group>
                              </div>
                            </b-list-group>
                          </b-card-text>
                        </b-card-body>
                      </b-collapse>
                    </b-card>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-card-text>
        </b-card>
      </div>

      <!-- ANALYTICS TAB (frontend-only for now) -->
      <div v-show="selectedMainTab === 'analytics'" class="home-analytics-tab">
        <home-analytics :events="itemsEventArray" />
      </div>
    </div>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BCardText,
  BButton,
  BCardFooter,
  BCardImg,
  BCardBody,
  BCardTitle,
  BCardSubTitle,
  BListGroup,
  BListGroupItem,
  BFormInput,
  BImg,
  BNav,
  BNavItem,
  BNavForm,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import {
  GetOrganizationListService,
  GetEventListService,
  GetEventDataService,
} from "@/apiServices/MasterServices";
import moment from "moment";
import HomeAnalytics from "./HomeAnalytics.vue";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BCardText,
    BButton,
    BCardFooter,
    BCardImg,
    BCardBody,
    BCardTitle,
    BCardSubTitle,
    BListGroup,
    BListGroupItem,
    BImg,

    BFormInput,

    BNav,
    BNavItem,
    BNavForm,
    HomeAnalytics,
  },
  data() {
    return {
      moment: moment,
      org_name: sessionStorage.getItem("userOrg"),
      orgArray: [],
      itemsEventArray: [],
      eventData: null,
      selectedEventId: null,
      selectedEventType: "",
      selectedEventBucket: "upcoming",
      eventSearch: "",
      selectedMainTab: "events",
      nextEventSnapshotData: null,
      nextEventSnapshotLoading: false,
      nextEventSnapshotLoadedForId: null,
    };
  },

  directives: {
    Ripple,
  },

  watch: {
    analyticsNextEvent: {
      handler(newVal) {
        const id = newVal && newVal.event_id ? newVal.event_id : null;
        if (id !== this.nextEventSnapshotLoadedForId) {
          this.loadNextEventSnapshot(id);
        }
      },
      immediate: true,
      deep: true,
    },
  },

  beforeMount() {
    // this.getOrgList();
    this.getEventList(1, "");
  },

  computed: {
    selectedEventBucketTitle() {
      return this.selectedEventBucket === "past"
        ? "Past Events"
        : "Upcoming Events";
    },
    displayedEvents() {
      const todayStart = moment().startOf("day");
      const events = Array.isArray(this.itemsEventArray)
        ? this.itemsEventArray
        : [];

      const normalized = events
        .filter(
          (e) => e && e.event_id && (e.event_start_date || e.event_end_date),
        )
        .map((e) => ({
          ...e,
          __start: e.event_start_date ? moment(e.event_start_date) : null,
          __end: e.event_end_date ? moment(e.event_end_date) : null,
        }));

      const isPast = (e) => (e.__end ? e.__end.isBefore(todayStart) : false);
      const isUpcomingOrOngoing = (e) =>
        e.__end ? e.__end.isSameOrAfter(todayStart) : true;

      const q = String(this.eventSearch || "")
        .trim()
        .toLowerCase();
      const matchesSearch = (e) =>
        !q ||
        String(e.event_name || "")
          .toLowerCase()
          .includes(q);

      if (this.selectedEventBucket === "past") {
        return normalized
          .filter(isPast)
          .filter(matchesSearch)
          .sort((a, b) => {
            const aEnd = a.__end ? a.__end.valueOf() : 0;
            const bEnd = b.__end ? b.__end.valueOf() : 0;
            return bEnd - aEnd;
          });
      }

      // Upcoming (includes ongoing): nearest start date first, then name
      return normalized
        .filter(isUpcomingOrOngoing)
        .filter(matchesSearch)
        .sort((a, b) => {
          const aStart = a.__start
            ? a.__start.valueOf()
            : Number.MAX_SAFE_INTEGER;
          const bStart = b.__start
            ? b.__start.valueOf()
            : Number.MAX_SAFE_INTEGER;
          if (aStart !== bStart) return aStart - bStart;
          return String(a.event_name || "").localeCompare(
            String(b.event_name || ""),
          );
        });
    },

    analyticsUpcomingCount() {
      const todayStart = moment().startOf("day");
      const events = Array.isArray(this.itemsEventArray)
        ? this.itemsEventArray
        : [];
      return events.filter((e) => {
        if (!e) return false;
        const end = e.event_end_date ? moment(e.event_end_date) : null;
        return !end || end.isSameOrAfter(todayStart);
      }).length;
    },
    analyticsPastCount() {
      const todayStart = moment().startOf("day");
      const events = Array.isArray(this.itemsEventArray)
        ? this.itemsEventArray
        : [];
      return events.filter((e) => {
        if (!e || !e.event_end_date) return false;
        return moment(e.event_end_date).isBefore(todayStart);
      }).length;
    },
    analyticsThisWeekCount() {
      const start = moment().startOf("week");
      const end = moment().endOf("week");
      const events = Array.isArray(this.itemsEventArray)
        ? this.itemsEventArray
        : [];
      return events.filter((e) => {
        if (!e || !e.event_start_date) return false;
        const d = moment(e.event_start_date);
        return d.isSameOrAfter(start) && d.isSameOrBefore(end);
      }).length;
    },
    analyticsThisMonthCount() {
      const start = moment().startOf("month");
      const end = moment().endOf("month");
      const events = Array.isArray(this.itemsEventArray)
        ? this.itemsEventArray
        : [];
      return events.filter((e) => {
        if (!e || !e.event_start_date) return false;
        const d = moment(e.event_start_date);
        return d.isSameOrAfter(start) && d.isSameOrBefore(end);
      }).length;
    },
    analyticsNextEvent() {
      const todayStart = moment().startOf("day");
      const events = Array.isArray(this.itemsEventArray)
        ? this.itemsEventArray
        : [];
      const upcoming = events
        .filter((e) => e && e.event_start_date)
        .map((e) => ({ ...e, __start: moment(e.event_start_date) }))
        .filter((e) => e.__start.isSameOrAfter(todayStart))
        .sort((a, b) => a.__start.valueOf() - b.__start.valueOf());
      return upcoming.length ? upcoming[0] : null;
    },
  },

  methods: {
    async getOrgList() {
      try {
        const response = await GetOrganizationListService({
          limit: 100,
        });
        if (response.data.status) {
          this.orgArray = response.data.Records.data;
          if (this.orgArray.length) {
            this.getEventList(this.orgArray[0].org_id);
          }
        } else {
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getEventList(org_id, selectedEventType) {
      try {
        if (
          window.location.hostname === "dashboard.therainbowtheater.com" ||
          window.location.hostname === "localhost"
        ) {
          org_id = 2;
        } else {
          org_id = org_id;
        }
        this.selectedEventType = selectedEventType;
        this.isBusy = true;
        const response = await GetEventListService({
          limit: 1000,
          org_id: org_id,
          selectedEventType: selectedEventType,
        });
        if (response.data.status) {
          this.itemsEventArray = response.data.Records;
          // Reset selected event when switching list contents
          this.selectedEventId = null;
          this.eventData = null;
          this.nextEventSnapshotData = null;
          this.nextEventSnapshotLoadedForId = null;
          // this.items = response.data.Records.data;
          // if (!isNaN(response.data.Records.pagination.total)) {
          //   this.pagination.totalRows = response.data.Records.pagination.total;
          // }
        } else {
        }
        this.isBusy = false;
      } catch (error) {
        this.isBusy = false;
        console.log(error);
      }
    },

    async loadNextEventSnapshot(eventId) {
      if (!eventId) {
        this.nextEventSnapshotData = null;
        this.nextEventSnapshotLoadedForId = null;
        return;
      }
      this.nextEventSnapshotLoading = true;
      try {
        const response = await GetEventDataService({
          limit: 1000,
          event_id: eventId,
          selectedEventType: this.selectedEventType,
        });
        if (response.data.status) {
          this.nextEventSnapshotData = response.data.Records;
          this.nextEventSnapshotLoadedForId = eventId;
        } else {
          this.nextEventSnapshotData = null;
          this.nextEventSnapshotLoadedForId = null;
        }
      } catch (error) {
        console.log(error);
        this.nextEventSnapshotData = null;
        this.nextEventSnapshotLoadedForId = null;
      } finally {
        this.nextEventSnapshotLoading = false;
      }
    },

    async getEventDataById(eventId) {
      try {
        this.eventData = null;
        this.isBusy = true;
        console.log(eventId, "eventId");
        const response = await GetEventDataService({
          limit: 1000,
          event_id: eventId,
          selectedEventType: this.selectedEventType,
        });
        if (response.data.status) {
          this.eventData = response.data.Records;
        } else {
        }
        this.isBusy = false;
        this.selectedEventId = eventId;
      } catch (error) {
        this.isBusy = false;
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.home-home__topbar {
  margin-bottom: 0.75rem;
}

.home-home__main-tabs {
  border: 1px solid rgba(26, 35, 50, 0.08);
  border-radius: 12px;
  background: #fff;
  padding: 0.25rem;
  width: fit-content;
}

.home-home__main-tabs ::v-deep .nav-link {
  border-radius: 10px;
  font-weight: 700;
  padding: 0.45rem 0.95rem;
  color: #6b7785;
}

.home-home__main-tabs ::v-deep .nav-link.active {
  background: #e85d04 !important;
  color: #fff !important;
}

.home-analytics__kpi {
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 12px;
  padding: 0.85rem 0.9rem;
  margin-bottom: 0.75rem;
}

.home-analytics__kpi-label {
  font-size: 0.8rem;
}

.home-analytics__kpi-value {
  font-size: 1.6rem;
  font-weight: 800;
  line-height: 1.1;
  margin-top: 0.2rem;
}

.home-analytics__card {
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.home-analytics__next-title {
  font-weight: 800;
  font-size: 1.05rem;
}

.home-analytics__snapshot-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 0.75rem;
}

.home-analytics__snapshot-item {
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 12px;
  padding: 0.65rem 0.75rem;
  background: rgba(0, 0, 0, 0.015);
}

.home-analytics__snapshot-value {
  font-size: 1.15rem;
  font-weight: 800;
  margin-top: 0.15rem;
}

.home-analytics__subhead {
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.72);
}

.home-analytics__mini-table td {
  padding: 0.35rem 0.45rem;
  font-size: 0.82rem;
}

.home-analytics__schedule-card {
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.home-analytics__schedule-title {
  font-weight: 800;
  font-size: 0.9rem;
}

.home-events__shell {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.home-events__header {
  padding: 0.9rem 1rem;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.02), rgba(0, 0, 0, 0));
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.home-events__title-row {
  display: flex;
  align-items: center;
}

.home-events__subtitle {
  font-size: 0.85rem;
  margin-top: 0.2rem;
}

.home-events__controls {
  margin-top: 0.25rem;
}

.home-events__tabs {
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.home-events__tab-btn {
  border: 0;
  min-width: 110px;
  font-weight: 600;
}

.home-events__search {
  width: 240px;
  border-radius: 10px;
}

.home-events__body {
  padding: 0.75rem 0.75rem 1rem;
}

.home-events__top-summary {
  margin-bottom: 0.75rem;
}

.home-events__kpi-stack {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  height: 100%;
}

.home-events__next-divider {
  border-color: rgba(0, 0, 0, 0.08);
}

.home-events__panel {
  border-radius: 10px;
  background: #fff;
  padding: 0.25rem;
}

.home-events__empty {
  padding: 1.25rem 0.75rem;
}

.home-events__event-card {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.02);
}

.home-events__event-header {
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  background: #fff;
}

.home-events__event-btn {
  text-align: left;
  white-space: normal;
  border-radius: 0;
  padding: 0.75rem 0.8rem;
  background: #fff;
}

.home-events__event-btn--active {
  background: rgba(0, 123, 255, 0.08);
}

.home-events__event-title {
  font-size: 0.95rem;
  line-height: 1.2;
}

.home-events__event-subtitle {
  font-size: 0.8rem;
}

td,
th {
  border: 1px solid rgba(0, 0, 0, 0.08);
  text-align: left;
  padding: 0.4rem 0.5rem;
}

table {
  border-collapse: collapse;
  width: 100%;
}
</style>
